import React, { useEffect } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import {
  useGetNewsCategoriesQuery,
  useDeleteNewsCategoryMutation,
} from '../../../../../redux/services/news';
import { routes } from '../../../../../utils/helpers/ApiClient';
import NewsCategoryTable from './NewsCategoryTable.jsx';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const NewsCategoryPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Kategórie aktualít') + ' - FRI CMS';
  }, []); // Runs on mount

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const {
    data: newsCategories,
    isLoading,
    refetch,
  } = useGetNewsCategoriesQuery();

  const [deleteNewsCategory, { isSuccess: isDeleteSuccess }] =
    useDeleteNewsCategoryMutation();

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Kategórie aktualít')}
        backUrl={routes.cmsNews}
        backUrlTooltip={t('Aktuality')}
        createText={t('Pridať kategóriu')}
        createUrl={routes.cmsNewsCategoriesCreate}
        permissionsBasic={'news-categories'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <NewsCategoryTable
            newsCategories={newsCategories}
            onDetailClick={(record) =>
              navigate(`${routes.cmsNewsCategoriesEdit}/${record.id}`)
            }
            onCreateClick={() => navigate(`${routes.cmsNewsCategoriesCreate}`)}
            onDeleteClick={(record) => deleteNewsCategory(record.id)} // <- volaj mutáciu
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default NewsCategoryPage;
